const progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};
export {
  progress
};
//# sourceMappingURL=progress.js.map
